var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_c('span',[_vm._v("版权所有：山西中智云达信息技术有限公司 ")]),_c('span',[_vm._v("2020-2025 All Rights Reserved.")])])])}]

export { render, staticRenderFns }